module.exports = __webpack_public_path__ + "static/img/cup.1032c741.png";